/**
 * Bottom tab bar (restyled 2026-10-17): Home / Explore / Create / Collection /
 * Profile. Create is a raised gradient button in the middle that opens the
 * Create hub page (#/create); Profile opens the Profile page.
 * Fixed to the viewport bottom, safe-area aware.
 */
import { icon } from './icon.js';

interface NavTab {
  name: string;
  label: string;
  href: string;
  icon: string;
}

const LEFT: NavTab[] = [
  { name: 'home', label: 'Home', href: '#/home', icon: 'home' },
  { name: 'explore', label: 'Explore', href: '#/explore', icon: 'explore' },
];
const RIGHT: NavTab[] = [
  { name: 'collection', label: 'Collection', href: '#/collection', icon: 'folder' },
  { name: 'profile', label: 'Profile', href: '#/profile', icon: 'person' },
];

function tabHtml(t: NavTab, active: string): string {
  const on = t.name === active;
  return `
    <a href="${t.href}" class="tab-item${on ? ' active' : ''}" ${on ? 'aria-current="page"' : ''}>
      ${icon(t.icon, { fill: on })}
      <span>${t.label}</span>
    </a>`;
}

/** Render into `host`, highlighting the active tab. */
export function renderBottomNav(host: HTMLElement, active: string): void {
  host.innerHTML = `
    <nav class="bottomnav-inner" aria-label="Primary">
      ${LEFT.map((t) => tabHtml(t, active)).join('')}
      <a class="tab-item tab-create${active === 'create' ? ' active' : ''}" href="#/create" ${active === 'create' ? 'aria-current="page"' : ''}>
        <span class="create-orb">${icon('add')}</span>
        <span>Create</span>
      </a>
      ${RIGHT.map((t) => tabHtml(t, active)).join('')}
    </nav>
  `;
}
